// src/components/Footer.js
import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  VStack,
  HStack,
  Link, // Kept for non-scrolling links
  SimpleGrid,
  IconButton,
  Input,
  Button,
  Divider,
  Image
} from '@chakra-ui/react';
import { FaFacebookF, FaTwitter, FaPinterestP, FaInstagram } from 'react-icons/fa';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import AnbalatLogo from '../assets/logo_.png';


// --- FIX: IMPORT THE MISSING COMPONENTS ---
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';

const Logo = () => {
  return (
   <VStack align="flex-start">
     <Image src={AnbalatLogo} w={70} h={70}/>
     <Text color={'white'} fontSize={24} fontWeight={'bold'}>
      Anbalat Construction </Text>
    
  
   </VStack>
  );
};

export default function Footer() {
  const bgColor = 'blue.900';
  const textColor = 'gray.300';
  const headingColor = 'white';

  // --- FIX: DECLARE THE MISSING VARIABLE ---
  const scrollLinkProps = {
    spy: true,
    smooth: true,
    offset: -70, // Adjust for sticky header
    duration: 500,
    style: { cursor: 'pointer' },
  };

  return (
    <Box as="footer" bg={bgColor} color={textColor}>
      <Box maxW="7xl" mx="auto" py={12} px={8}>
        {/* Top Section */}
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align="center"
          mb={10}
        >
          <Heading as="h2" size="lg" color={headingColor}>
            Let's Connect there
          </Heading>
          <Button      as={RouterLink}
                      to="/contact" colorScheme="orange" size="lg" mt={{ base: 4, md: 0 }}
          
           
          >
            Contact Us
          </Button>
        </Flex>

        {/* Main Footer Grid */}
        <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={8}>
          {/* Column 1: Logo and Info */}
          <VStack align="flex-start" spacing={4}>
            <Logo />
            <Text>
              Committed to building the future on a foundation of integrity and quality craftsmanship, we deliver structures that stand the test of time.
            </Text>
            <HStack spacing={3}>
              <IconButton as="a" href="#" aria-label="Facebook" icon={<FaFacebookF />} isRound variant="ghost" colorScheme="whiteAlpha" />
              <IconButton as="a" href="#" aria-label="Twitter" icon={<FaTwitter />} isRound variant="ghost" colorScheme="whiteAlpha" />
              <IconButton as="a" href="#" aria-label="Pinterest" icon={<FaPinterestP />} isRound variant="ghost" colorScheme="whiteAlpha" />
              <IconButton as="a" href="#" aria-label="Instagram" icon={<FaInstagram />} isRound variant="ghost" colorScheme="whiteAlpha" />
            </HStack>
          </VStack>

          {/* Column 2: Navigation - This part is now correct */}
          <VStack align="flex-start" spacing={4}>
            <Heading as="h4" size="md" color={headingColor}>Navigation</Heading>
            <ScrollLink to="team" {...scrollLinkProps}>Our Team</ScrollLink>
            <ScrollLink to="contact" {...scrollLinkProps}>Contact Us</ScrollLink>
            <RouterLink to="/about">About Us</RouterLink>
            <ScrollLink to="testimonials" {...scrollLinkProps}>Testimonial</ScrollLink>
            <ScrollLink to="faqs" {...scrollLinkProps}>FAQs</ScrollLink>
          </VStack>

          {/* Column 3: Contact */}
          <VStack align="flex-start" spacing={4}>
            <Heading as="h4" size="md" color={headingColor}>Contact</Heading>
            <Text>+25193223322</Text>
            <Text>info@anbelat.com</Text>
            <Text>Ethiopia, Oromia adama</Text>
          </VStack>

          {/* Column 4: Newsletter */}
          <VStack align="flex-start" spacing={4}>
            <Heading as="h4" size="md" color={headingColor}>Get the latest information</Heading>
            <HStack as="form" w="full">
              <Input
                placeholder="Email address"
                bg="blue.800"
                border="1px"
                borderColor="blue.700"
                _placeholder={{ color: 'gray.400' }}
              />
              <IconButton
                aria-label="Subscribe"
                icon={<ArrowForwardIcon />}
                colorScheme="orange"
                type="submit"
              />
            </HStack>
          </VStack>
        </SimpleGrid>

        {/* Bottom Bar: Copyright */}
        <Divider my={10} borderColor="blue.700" />
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align="center"
          fontSize="sm"
        >
          <Text>Copyright © 2025 Anbelat.com. All Rights Reserved.</Text>
          <HStack spacing={4} mt={{ base: 4, md: 0 }}>
            <Link href="#">User Terms & Conditions</Link>
            <Link href="#">Privacy Policy</Link>
          </HStack>
        </Flex>
      </Box>
    </Box>
  );
}